<button
	cdxButton
	fillStyle="secondaryOutline"
	[chip]="true"
	[inline]="true"
	[checked]="filterOption.isSelected"
	class="filter-trigger specials-button"
	focusVisibleStyle="dark-dashed"
	(click)="toggleFilter(filterOption)"
	data-testid="filter-toggle"
>
	<cdx-svg-icon
		*ngIf="filterOption.isSelected"
		name="tick"
		size="very-small"
		fill="currentColor"
		class="prefix-icon"
	></cdx-svg-icon>
	{{ filterOption.filter.name }}
</button>
